import { Navigate, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import { store } from "./components/forms/store";

import Login from "./components/routes/Login";
import ForgotPassword from "./components/routes/ForgotPassword";
import Register from "./components/routes/Register";
import Home from "./components/routes/Home";
import About from "./components/routes/About";
import AdminHome from "./components/routes/AdminHome";
import AdminManagement from "./components/routes/AdminManagement";
import AdminCreateUser from "./components/routes/AdminCreateUser";
import AdminEditUser from "./components/routes/AdminEditUser";
import AdminAssignors from "./components/routes/AdminAssignors";
import AdminAssignorProjects from "./components/routes/AdminAssignorProjects";
import AdminContractors from "./components/routes/AdminContractors";
import AdminContractorProjects from "./components/routes/AdminContractorProjects";
import AdminStats from "./components/routes/AdminStats";
import AssignorStatistics from "./components/routes/AssignorStatistics";
import Projects from "./components/routes/Projects";
import MyProfile from "./components/routes/MyProfile";
import ProjectPublishPage from "./components/routes/ProjectPublish";
import ProjectEdit from "./components/routes/ProjectEdit";
import ProjectFinished from "./components/routes/ProjectFinished";
import AdminRoute from "./components/navigation/AdminRoute";
import ProtectedRoute from "./components/navigation/ProtectedRoute";
import NotAuthenticatedRoute from "./components/navigation/NotAuthenticatedRoute";
import Root from "./components/routes/Root";
import Layout from "./components/elements/Layout";

import { NotificationsProvider } from "./contexts/notificationsContext";
import { AuthContextProvider } from "./contexts/authContext";

import "./styles/Styles.css";
import "react-toastify/dist/ReactToastify.css";
import "react-medium-image-zoom/dist/styles.css";
import AdminLogin from "./components/routes/AdminLogin";
import SupervisionInvite from "./components/routes/SupervisionInvite";

function App() {
  return (
    <div>
      <Provider store={store}>
        <AuthContextProvider>
          <NotificationsProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<Root />} />
                <Route
                  path="/login"
                  element={
                    <NotAuthenticatedRoute>
                      <Login />
                    </NotAuthenticatedRoute>
                  }
                />
                <Route
                  path="/login/forgot-password"
                  element={
                    <NotAuthenticatedRoute>
                      <ForgotPassword />
                    </NotAuthenticatedRoute>
                  }
                />
                <Route
                  path="/register"
                  element={
                    <NotAuthenticatedRoute>
                      <Register />
                    </NotAuthenticatedRoute>
                  }
                />
                <Route path="/home" element={<Home />} />
                <Route path="/supervision-invite" element={<SupervisionInvite />} />

                {/* TODO: DELETE ROUTE  */}
                <Route
                  path="/admin/login"
                  element={
                    <NotAuthenticatedRoute>
                      <AdminLogin />
                    </NotAuthenticatedRoute>
                  }
                />
                <Route path="/about" element={<About />} />

                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminHome />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/management"
                  element={
                    <AdminRoute>
                      <AdminManagement />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/management/create-user"
                  element={
                    <AdminRoute>
                      <AdminCreateUser />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/management/edit-user/:id"
                  element={
                    <AdminRoute>
                      <AdminEditUser />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/assignors"
                  element={
                    <AdminRoute>
                      <AdminAssignors />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/assignor/:id"
                  element={
                    <AdminRoute>
                      <AdminAssignorProjects />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/contractors"
                  element={
                    <AdminRoute>
                      <AdminContractors />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/contractor/:id"
                  element={
                    <AdminRoute>
                      <AdminContractorProjects />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/statistics"
                  element={
                    <AdminRoute>
                      <AdminStats />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/statistics/:id"
                  element={
                    <AdminRoute>
                      <AssignorStatistics />
                    </AdminRoute>
                  }
                />

                <Route
                  path="/projects"
                  element={
                    <ProtectedRoute>
                      <Projects />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/projects/:id/publish"
                  element={
                    <ProtectedRoute>
                      <ProjectPublishPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/projects/:id/edit"
                  element={
                    <ProtectedRoute>
                      <ProjectEdit />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/projects/:id/finished"
                  element={
                    <ProtectedRoute>
                      <ProjectFinished />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/my-profile"
                  element={
                    <ProtectedRoute>
                      <MyProfile />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>

            <ToastContainer
              position="bottom-right" // ⬅️ Bottom right
              hideProgressBar={true} // ⬅️ Hide the progress bar
              newestOnTop={true} // Optional: show newest on top
              closeOnClick={true} // Allow click to close
              pauseOnHover={true} // Pause timer on hover (not needed if autoClose=false)
              draggable={true}
            />
          </NotificationsProvider>
        </AuthContextProvider>
      </Provider>
    </div>
  );
}

export default App;
